module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('h2', [_vm._v("Welcome to Owal Faces")]), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', [_vm._v("\n    To see the list of enrolled faces, go to "), _c('router-link', {
    attrs: {
      "to": "/faces"
    }
  }, [_vm._v("Faces List")]), _vm._v(".\n\n    There, you can see who walked where. Tip: Check out the Filter feature for quick lookup!\n\n    "), _c('br'), _vm._v("\n\n    To help us train the detector, click "), _c('router-link', {
    attrs: {
      "to": "/detected"
    }
  }, [_vm._v("Faces Detected")]), _vm._v(". It becomes more accurate with every click!\n  ")], 1) : _c('div', [_vm._v("\n    To start, please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("log in")]), _vm._v(".\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bd8c06e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 305
// module chunks = 1